import i18n from '../../language/index'
import img_effects from '@/base/img_effects'
export default {
  img_effects, //不知道这个是啥 但是去掉会报错
  pc_widgets_infor: {
    width:{ // 弹框宽度
      radio_val:'default',
      default:{
        width:200,
      },
      custom:{
        width:200,
      }
    },
    height:{ // 弹框宽度
      radio_val:'default',
      default:{
        height:200,
      },
      custom:{
        height:200,
      }
    },
    //背景
    background:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
    // 阴影
    boxShadow: {
      radio_val: 'default',
      default: {
        direction: 'outset',
        x: 0,
        y: 0,
        spread: 0,
        blur: 0,
        color: 'rgba(0,0,0,0.3)',
        seColor: 'rgba(0,0,0,0.5)',
      },
      custom: {
        direction: 'outset',
        x: 0,
        y: 0,
        spread: 0,
        blur: 4,
        color: 'rgba(0,0,0,0.3)',
        seColor: 'rgba(0,0,0,0.5)',
      }
    },
    // 位置
    position: 'center_center',
    //触发
    trigger: 'one',
    playSet: { // 多次触发 
      delay: 1, // 持续时间  延迟
      space: 1 // 间隔
    },
  },
  mb_widgets_infor: {},
  listArr: {
    content: i18n.t('widgets_basic_floating_frame_style_542')
  }
}


// WEBPACK FOOTER //
// ./src/widgets/basic_floating_frame/style.js